import { AppSubStore, AppSubStoreArgs } from "@/store/types";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { PlatformAccountState } from "@/store/platform-info/types";
import { GatedFeature, GateUsage } from "@/store/feature-gates/types";

export class SettingsSubscriptionManagementPageStore extends AppSubStore {
  constructor(injectedDeps: AppSubStoreArgs) {
    super(injectedDeps);

    makeObservable(this, {
      hasActiveSubscription: computed,
      openSubscriptionModal: action,
      refreshUsage: action,
      notesUsage: observable,
      chatUsage: observable,
      isUsageLoading: observable,
    });
  }

  get hasActiveSubscription() {
    return this.store.platformInfo.accountState === PlatformAccountState.Active;
  }

  notesUsage: GateUsage | undefined = undefined;
  chatUsage: GateUsage | undefined = undefined;
  isUsageLoading = false;

  async refreshUsage(): Promise<void> {
    this.isUsageLoading = true;
    try {
      const [notes, chat] = await Promise.all([
        this.store.featureGates.checkGate(GatedFeature.NoteCreate),
        this.store.featureGates.checkGate(GatedFeature.ChatMessageSend),
      ]);

      runInAction(() => {
        this.notesUsage = notes;
        this.chatUsage = chat;
      });
    } finally {
      runInAction(() => {
        this.isUsageLoading = false;
      });
    }
  }

  public openSubscriptionModal() {
    this.store.platformInfo.openSubscribeNowInterstitial();
  }
}
